/**
 * 施策のステータス
 */
const measureStatus = {
  1: '検証中',
  2: '完了',
  9: 'データなし'
}

export default measureStatus
